import React from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { withAccount } from '../../components/AccountContext';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';
import { Loading } from '../../components/Loading';
import CommercialAgreementList from './CommercialAgreementList';

const COMMERCIAL_AGREEMENT_LIST_QUERY = gql`
  query listCommercialAgreements(
        $accountId: ID!,
        $after: String,
        $before: String,
        $first: Int,
        $last: Int,
        $filter: CommercialAgreementFilter,
        $sort: CommercialAgreementSortSpecifier) {
      account(id: $accountId) {
      id
      commercialAgreements(after: $after, before: $before, first: $first, last: $last, filter: $filter, sort: $sort) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        totalCount
        indexFrom
        indexTo
        edges {
          node {
            id
            promisee {
              id
              displayName
            }
            uploadUrl
            createdOn
          }
        }
      }
    }
  }
`;

const DELETE_COMMERCIAL_AGREEMENT = gql`
  mutation deleteCommercialAgreement($input: DeleteCommercialAgreementInput!) {
    deleteCommercialAgreement(input: $input) {
      accountId,
      commercialAgreementId
    }
  }
`;

const CommercialAgreementListContainer = (props) => {
  const { currentAccount, location } = props;
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
    filter: params.filter,
  };

  return (
    <Query
      query={COMMERCIAL_AGREEMENT_LIST_QUERY}
      variables={variables}
      fetchPolicy="network-only"
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }

        if (error) return `Error! ${error.message}`;

        const connection = data && data.account ? data.account.commercialAgreements : emptyConnection();

        return (
          <Mutation mutation={DELETE_COMMERCIAL_AGREEMENT}>
            {deleteCommercialAgreement => (
              <CommercialAgreementList
                currentAccount={currentAccount}
                connection={connection}
                loading={loading}
                deleteCommercialAgreement={deleteCommercialAgreement}
              />
            )}
          </Mutation>
        );
      }}
    </Query>
  );
};
CommercialAgreementListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(CommercialAgreementListContainer)));
